import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import Swal from "sweetalert2";
import {
  addApplication,
  getApplicationById,
  updateApplication,
} from "../../../services/ApplicationService";
import { Button } from "react-bootstrap";

const AddApplication = () => {
  const [applicationName, setApplicationName] = useState("");
  const { id } = useParams();
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (id) {
      const fetchApplication = async () => {
        try {
          const response = await getApplicationById(id);
          const application = response.data;
          setApplicationName(application.data.title);
        } catch (err) {
          console.error("Error fetching application:", err);
        }
      };
      fetchApplication();
    }
  }, [id]);

  const validateForm = () => {
    const newErrors = {};

    if (!applicationName.trim()) {
      newErrors.applicationName = "Title is required";
    }

    setErrors(newErrors);

    // Return true if no errors
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    try {
      // --- VALIDATE FORMS ---
      const formValid = validateForm();
      if (!formValid) {
        return;
      }
      const applicationData = { title: applicationName };

      if (id) {
        // --- UPDATE EXISTING COUNTRY ---
        await updateApplication(id, applicationData);

        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Application details updated successfully",
        });
        navigate("/application", {
          state: {
            page: location.state?.page || 1,
            searchTerm: location.state?.searchTerm || "",
          },
        });
      } else {
        // --- CREATE NEW COUNTRY ---
        const response = await addApplication(applicationData);
        if (response.data.success) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Application added successfully",
          });
          navigate("/application", {
            state: {
              page: location.state?.page || 1,
              searchTerm: location.state?.searchTerm || "",
            },
          });
        }
      }
    } catch (err) {
      console.error("Error in handleSave:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.response?.data?.message || "Operation failed",
      });
    }
  };
  return (
    <>
      <PageTitle
        activeMenu={`${id ? "Edit Application" : "Add Application"}`}
        motherMenu="Application"
        activeMenuLink={`${id ? `edit-application/${id}` : "add-application"}`}
        motherMenuLink={"application"}
      />
      <div className="row">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-12 col-xxl-12">
              <div className="card h-auto">
                <div className="card-body">
                  <form>
                    <div
                      onClick={() => {
                        navigate("/application", {
                          state: {
                            page: location.state?.page || 1,
                            searchTerm: location.state?.searchTerm || "",
                          },
                        });
                      }}
                      className="mb-4 d-flex align-items-center flex-wrap gap-2 cursor-pointer w-max"
                    >
                      <i className="fas fa-chevron-left"></i>
                      <div>Application List</div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label" htmlFor="title">
                        Title
                      </label>
                      <input
                        id="title"
                        type="text"
                        className="form-control w-full"
                        placeholder="Title"
                        value={applicationName} // bind value
                        onChange={(e) => setApplicationName(e.target.value)} // update state
                      />
                      {errors?.applicationName && (
                        <div className="text-danger mb-3 mt-1" id="title-error">
                          {errors.applicationName}
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              </div>
              <hr style={{ margin: "0px" }} className="mx-2" />
              <div className="card-footer border-0 text-end py-3 d-flex justify-content-end gap-2">
                <Button
                  type="button"
                  variant="secondary"
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => {
                    navigate("/application", {
                      state: {
                        page: location.state?.page || 1,
                        searchTerm: location.state?.searchTerm || "",
                      },
                    })
                  }}
                >
                  Back
                </Button>

                {/* Save / Update Button */}
                <Button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={handleSave}
                >
                  {id ? "Update" : "Save"}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddApplication;
